import { api } from "@/services";
import qs from "qs";

const PrimaryStore = process.env.NEXT_PUBLIC_PRIMARY_STORE;
const SecondaryStore = process.env.NEXT_PUBLIC_SECONDARY_STORE;

const StoresParams = {
  stores: [PrimaryStore, SecondaryStore]
};

const RepeatParamsSerializer = (params) => qs.stringify(params, { arrayFormat: "repeat" });

export async function useAsyncBrands() {
  let Response = null;
  let BError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.get("/Vehicles/GetBrands", {
        signal: Controller.signal
      });
      if (Resp.status === 200 && Resp?.data?.value) {
        Response = Resp.data.value;
      } else {
        BError = "Nenhuma Marca encontrada";
      }
    } catch (Err) {
      BError = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, BError];
}

export async function useAsyncModelsByBrand(Brand: string) {
  let Response = null;
  let BError = null;

  if (!Brand) {
    return [Response, "Nenhuma marca informada"];
  }

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.get("/Vehicles/GetVehiclesByBrand", {
        signal: Controller.signal,
        params: { brand: Brand }
      });
      if (Resp.status === 200 && Resp?.data?.length > 0) {
        Response = Resp.data;
      } else {
        BError = "Nenhum Modelo encontrado";
      }
    } catch (Err) {
      BError = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, BError];
}

export async function useAsyncYearsByModelBrand(Brand: string, Model: string) {
  let Response = null;
  let BError = null;

  if (!Brand || !Model) {
    return [Response, "Nenhuma marca ou modelo informado"];
  }

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.get("/Vehicles/GetYearsCompositionsByBrandModel", {
        signal: Controller.signal,
        params: { brand: Brand, model: Model }
      });
      if (Resp.status === 200 && Resp?.data?.value) {
        Response = Resp.data.value;
      } else {
        BError = "Nenhum Modelo encontrado";
      }
    } catch (Err) {
      BError = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, BError];
}

export async function useAsyncWidths() {
  let Response = null;
  let BError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.get("/Products/GetWidth", {
        signal: Controller.signal,
        params: StoresParams,
        paramsSerializer: RepeatParamsSerializer
      });
      if (Resp.status === 200) {
        Response = Resp.data;
      } else {
        BError = "Nenhuma largura encontrada";
      }
    } catch (Err) {
      BError = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, BError];
}

export async function useAsyncSeries(Widht: string) {
  let Response = null;
  let BError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.get("/Products/GetSeries", {
        signal: Controller.signal,
        params: {
          ...StoresParams,
          width: Widht
        },
        paramsSerializer: RepeatParamsSerializer
      });
      if (Resp.status === 200) {
        Response = Resp.data;
      } else {
        BError = "Nenhuma altura encontrada";
      }
    } catch (Err) {
      BError = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, BError];
}

export async function useAsyncRims(Widht: string, Series: string) {
  let Response = null;
  let BError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.get("/Products/GetRim", {
        signal: Controller.signal,
        params: {
          ...StoresParams,
          width: Widht,
          series: Series
        },
        paramsSerializer: RepeatParamsSerializer
      });
      if (Resp.status === 200) {
        Response = Resp.data;
      } else {
        BError = "Nenhum aro encontrado";
      }
    } catch (Err) {
      BError = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, BError];
}
